import {ColorObjectStrategy} from "../../../../_types/ColorObjectStrategy";
import type {SceneObjectWithColorData} from "../../../../_types/SceneObjectWithColorData";
import type {WebGLRenderObject} from "../../../../_types/WebGLRenderObject";
import {getWeightedRandom} from "../../../../helpers/getWeightedRandom";

export class RandomColorObjectStrategy implements ColorObjectStrategy {

    constructor(private maxColors?: number) {
    }
    // eslint-disable-next-line prefer-arrow/prefer-arrow-functions
    public color(
        object: WebGLRenderObject,
        sceneObject: SceneObjectWithColorData
    ): void {

        const colors = this.maxColors
            ? sceneObject.data.palettes[this.maxColors]
            : sceneObject.data.uniqueColors;

        object.color = getWeightedRandom(colors);
    }
}